"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function classNameForCellSpan(span, screen) {
    if (screen === void 0) { screen = null; }
    var className = constants_1.CELL_BASE_CLASS_NAME + "--span-" + span;
    if (screen != null) {
        return className + "-" + screen;
    }
    else {
        return className;
    }
}
exports.classNameForCellSpan = classNameForCellSpan;
function classNameForCellOrder(order) {
    return constants_1.CELL_BASE_CLASS_NAME + "--order-" + order;
}
exports.classNameForCellOrder = classNameForCellOrder;
function classNameForCellAlignment(alignment) {
    return constants_1.CELL_BASE_CLASS_NAME + "--align-" + alignment;
}
exports.classNameForCellAlignment = classNameForCellAlignment;
function normalizeMarginAndGutter(value) {
    if (typeof value === "number") {
        return value + "px";
    }
    else {
        return value;
    }
}
exports.normalizeMarginAndGutter = normalizeMarginAndGutter;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/layout-grid/lib/utils.js
// module id = ./node_modules/@react-mdc/layout-grid/lib/utils.js
// module chunks = 1 2